var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.biz)?_c('div',[_c('div',[_vm._v(_vm._s(_vm._f("address")(_vm.biz.address)))]),(_vm.biz.phones && _vm.biz.phones.length)?_c('div',[_vm._v(_vm._s(_vm._f("phone")(_vm.biz.phones[0].number)))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }